module.exports = __webpack_public_path__ + "img/hbt.a32da9d9.png";